import Vue from 'vue';

function getSocialIdFromCookie(cookieKey) {
  var match = document.cookie.match(
    new RegExp("(^| )" + cookieKey + "=([^;]+)")
  );
  if (match) return match[2];
}

function initialState() {
    return {
        socialAccounts: [],
        editingAccount: {
          Name: '',
          SocialTypeID: null,
          Active: false,
          SocialUrl: '',
          Username: '',
          Password: '',
          Email: '',
          ApiKey: ''
        },
        showAccountModal: false
    }
}

const state = initialState();

const actions = {
  getSocialAccounts: function(context, param) {
    var queryString = "?";
    if(param.length>1) {
      param.forEach(function(store) {
        queryString += "platformIds=" + store.AccountPlatformID + "&";
      })
    }
    else queryString += "platformIds=" + param[0].AccountPlatformID;
    return new Promise((resolve, reject) => {
      Vue.http.get("/curator/socialplatforms" + queryString).then(function(response) {
        resolve(response);
      }).catch(function(error){
        reject(error);
      })
    });
  },
  saveSocialAccount: function(context, param) {
    return new Promise((resolve, reject) => {
      if(param.AccountPlatformSocialID != null && param.AccountPlatformSocialID > 0) {
        Vue.http.put("/curator/saveSocialPlatform", param).then(function(response) {
          resolve(response);
        }).catch(function(error) {
          reject(error);
        })
      }
      else {
        Vue.http.post("/curator/saveSocialPlatform", param).then(function(response) {
          resolve(response);
        }).catch(function(error) {
          reject(error);
        })
      }
    })
  },
  getRedirectUrl: function(context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get("/curator/getredirecturlforsocialnetwork?socialId=" + param.socialId + "&redirectToUrl=" + param.url).then(function(response) {
        resolve(response);
      }).catch(function(error) {
        reject(error);
      });
    });
  },
  authorizeAccount: function(context, param) {
    let socialId = getSocialIdFromCookie(context.getters.cookieKey);
    let redirectUrl = window.location.protocol + "//" + window.location.host;
      if (redirectUrl.substr(redirectUrl.length - -1) != "/") redirectUrl += "/";

    return new Promise((resolve, reject) => {
      var queryString = "?socialId=" + socialId + "&redirectToUrl=" + redirectUrl;
      if(param.Code)
        queryString += "&code=" + param.Code;
      if(param.OAuthToken)
        queryString += "&oauthToken=" + param.OAuthToken;
      if(param.OAuthVerifier)
        queryString += "&oauthVerifier=" + param.OAuthVerifier;
      Vue.http.post("/curator/authorizedealersocialnetwork" + queryString).then(function(response) {
        resolve(response);
      }).catch(function(error) {
        reject(error);
      })
    })
  },
  getFacebookPages: function(context, userId) {
    return new Promise((resolve, reject) => {
      Vue.http.get("/curator/getFacebookPages?userId=" + userId).then(function(response) {
        resolve(response);
      }).catch(function(error) {
        reject(error);
      })
    })
  },
  deleteAccount: function(context, id) {
    return new Promise((resolve, reject) => {
      Vue.http.delete("/curator/deleteSocialPlatform?socialId=" + id).then(function(response) {
        resolve(response);
      }).catch(function(error) {
        reject(error);
      })
    })
  }
}

const mutations = {
  toggleAccountModal: function(state, data) {
    state.showAccountModal = data;
  },
  setSocialAccounts: function(state, data) {
    state.socialAccounts = data;
  },
  setEditingAccount: function(state, data) {
    state.editingAccount = data;
  }
}

const getters = {
  socialAccounts: function() {
      return state.socialAccounts;
  },
  showAccountModal: function() {
    return state.showAccountModal;
  },
  editingAccount: function() {
    return state.editingAccount;
  },
  cookieKey: function(state) {
    return process.env.COOKIE_SOCIAL_USERID_KEY;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}


// WEBPACK FOOTER //
// ./src/store/modules/SocialAccounts.js